import { render, staticRenderFns } from "./CRUDTable2.vue?vue&type=template&id=c1757c30"
import script from "./CRUDTable2.vue?vue&type=script&lang=js"
export * from "./CRUDTable2.vue?vue&type=script&lang=js"
import style0 from "./CRUDTable2.vue?vue&type=style&index=0&id=c1757c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports